import { render } from "./SuccessOk.vue?vue&type=template&id=5c477cb2&scoped=true"
import script from "./SuccessOk.vue?vue&type=script&lang=js"
export * from "./SuccessOk.vue?vue&type=script&lang=js"

import "./SuccessOk.vue?vue&type=style&index=0&id=5c477cb2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c477cb2"]])

export default __exports__